export default __webpack_public_path__ + "static/media/midaslifecare_logo.0fc771d8.png";